import React from 'react';
import styles from './ProfessionalChartLoader.module.scss';

interface ProfessionalChartLoaderProps {
  metricName?: string;
}

export default function ProfessionalChartLoader({ metricName = "Graphique" }: ProfessionalChartLoaderProps) {
  return (
    <div className={styles.professionalLoader}>
      <div className={styles.loaderContainer}>
        <div className={styles.loaderSpinner}>
          <div className={styles.spinnerRing}></div>
          <div className={styles.spinnerRing}></div>
          <div className={styles.spinnerRing}></div>
        </div>
        
        <div className={styles.loaderContent}>
          <h3 className={styles.loaderTitle}>Chargement des données</h3>
          <p className={styles.loaderMessage}>
            Récupération des données {metricName.toLowerCase()} en cours...
          </p>
          <div className={styles.loaderProgress}>
            <div className={styles.progressBar}>
              <div className={styles.progressFill}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
